import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MessageService, ToastMessage } from '../../services/message.service';

export type ToastPosition = 'top-center' | 'bottom-center';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './app-toast.component.html',
  styleUrl: './app-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppToastComponent {
  readonly position = input<ToastPosition>('bottom-center');
  protected readonly messageService = inject(MessageService);

  protected dismiss(message: ToastMessage): void {
    this.messageService.dismiss(message.id);
  }
}
